<template>
    <v-dialog
        v-model="warning.dialog"
        persistent
        width="30vw">
        <v-card style="padding:10px">
            <v-card-title class="d-flex justify-center align-center text-center">
                <v-btn
                    icon
                    style="position:absolute;top:0;left:0"
                    @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-icon color="red">mdi-alert-circle</v-icon> Warning
            </v-card-title>
            <v-divider horizontal></v-divider>
            <v-card-text class="mt-5">
                <v-row class="mb-3 text-center" align="center" justify="center">
                    {{ warning.message }}
                </v-row>
                <v-row justify="center">
                    <v-btn
                        color="primary"
                        @click="closeDialog()"
                        :href="warning.directory.path">
                        <v-icon>{{ warning.directory.icon }}</v-icon>
                        {{ warning.directory.message }}
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        warning: {Type: Object}
    },
    data() {
        return {
            dialog: false,
        }
    },
    methods: {
        closeDialog() {
            this.$emit('input',false)
        }
    }
}
</script>

<style>

</style>